import ApiService from '@/core/services/ApiService';
import { Actions, Mutations } from '@/store/enums/StoreEnums';
import { Module, Action, Mutation, VuexModule } from 'vuex-module-decorators';

export interface IndicesPropertyCategoryObject {
  id: number;
  property_category_en: string;
  property_category_ar: string;
}

export interface IndexTypeViewTypeObject {
  id: number;
  index_type_id: number;
  title_en: string;
  title_ar: string;
  slug: string;
  sort: number;
}

@Module
export default class IndicesAssetsModule extends VuexModule {
  indicesPropertyCategories = [] as Array<IndicesPropertyCategoryObject>;

  get allListIndicesPropertyCategories(): Array<IndicesPropertyCategoryObject> {
    return this.indicesPropertyCategories;
  }

  @Mutation
  [Mutations.SET_ALL_INDICES_PROPERTY_CATEGORIES](data) {
    this.indicesPropertyCategories = data.data;
  }

  @Action
  [Actions.GET_ALL_INDEX_TYPE_VIEW_TYPES](indexTypeId: number) {
    ApiService.setAuthorizationHeader();
    return ApiService.get(`/indices/view-types?indexTypeId=${indexTypeId}`)
      .then(({ data }) => data.data)
      .catch(({ response }) => {
        console.error(response);
      });
  }

  @Action
  [Actions.GET_ALL_INDICES_PROPERTY_CATEGORIES]() {
    ApiService.setAuthorizationHeader();
    return ApiService.get('/indices/property-categories')
      .then(({ data }) => {
        this.context.commit(
          Mutations.SET_ALL_INDICES_PROPERTY_CATEGORIES,
          data
        );
        return data.data;
      })
      .catch(({ response }) => {
        console.error(response);
      });
  }
}
